export default __webpack_public_path__ + "static/media/logo-polygon-icon.e75cb119.png";